import { render, staticRenderFns } from "./BookingRequestInfoIcon.vue?vue&type=template&id=35d62808&scoped=true&lang=html&"
import script from "./BookingRequestInfoIcon.vue?vue&type=script&lang=js&"
export * from "./BookingRequestInfoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d62808",
  null
  
)

export default component.exports